var map = {
	"./Buyer/Order/Action.vue": [
		"d2ac",
		"view-Buyer-Order-Action-vue"
	],
	"./Buyer/Order/Detail.vue": [
		"ddf2",
		"Client0~CommonCode0~Order0~OrderAck0~OrderAmount0~OrderAnalysis0~ProductCode0~Purchase0~PurchaseTax0~aac84a3b",
		"Client0~CommonCode0~Order0~OrderAck0~OrderAmount0~OrderAnalysis0~ProductCode0~Purchase0~PurchaseTax0~c2760ff0",
		"view-Code-Client-DetailForm-vue",
		"Client0",
		"view-Buyer-Order-Detail-vue"
	],
	"./Buyer/Order/DetailForm.vue": [
		"0f26",
		"Client0~CommonCode0~Order0~OrderAck0~OrderAmount0~OrderAnalysis0~ProductCode0~Purchase0~PurchaseTax0~aac84a3b",
		"Client0~CommonCode0~Order0~OrderAck0~OrderAmount0~OrderAnalysis0~ProductCode0~Purchase0~PurchaseTax0~c2760ff0",
		"ShipCode0~view-Buyer-Order-DetailForm-vue~view-Buyer-Purchase-DetailForm-vue~view-Buyer-PurchaseTax-~73523415",
		"view-Buyer-Order-DetailForm-vue"
	],
	"./Buyer/Order/Item.vue": [
		"5a0d",
		"Client0~CommonCode0~Order0~OrderAck0~OrderAmount0~OrderAnalysis0~ProductCode0~Purchase0~PurchaseTax0~aac84a3b",
		"Client0~CommonCode0~Order0~OrderAck0~OrderAmount0~OrderAnalysis0~ProductCode0~Purchase0~PurchaseTax0~c2760ff0",
		"view-Code-Client-DetailForm-vue",
		"Client0",
		"view-Buyer-Order-Item-vue"
	],
	"./Buyer/Order/List.vue": [
		"c27e",
		"view-Buyer-Order-List-vue~view-Buyer-Purchase-List-vue~view-Buyer-PurchaseTax-List-vue~view-Buyer-Qu~bde1fb3b",
		"view-Buyer-Order-List-vue"
	],
	"./Buyer/Order/Main.vue": [
		"91e5",
		"Client0~CommonCode0~Order0~OrderAck0~OrderAmount0~OrderAnalysis0~ProductCode0~Purchase0~PurchaseTax0~aac84a3b",
		"Client0~CommonCode0~Order0~OrderAck0~OrderAmount0~OrderAnalysis0~ProductCode0~Purchase0~PurchaseTax0~c2760ff0",
		"view-Code-Client-DetailForm-vue",
		"Client0",
		"Order0"
	],
	"./Buyer/Order/SearchPanel.vue": [
		"27a5",
		"Client0~CommonCode0~Order0~OrderAck0~OrderAmount0~OrderAnalysis0~ProductCode0~Purchase0~PurchaseTax0~aac84a3b",
		"view-Buyer-Order-SearchPanel-vue"
	],
	"./Buyer/Purchase/Action.vue": [
		"33ad",
		"view-Buyer-Purchase-Action-vue"
	],
	"./Buyer/Purchase/Detail.vue": [
		"4f56",
		"Client0~CommonCode0~Order0~OrderAck0~OrderAmount0~OrderAnalysis0~ProductCode0~Purchase0~PurchaseTax0~aac84a3b",
		"Client0~CommonCode0~Order0~OrderAck0~OrderAmount0~OrderAnalysis0~ProductCode0~Purchase0~PurchaseTax0~c2760ff0",
		"view-Code-Client-DetailForm-vue",
		"Client0",
		"view-Buyer-Purchase-Detail-vue"
	],
	"./Buyer/Purchase/DetailForm.vue": [
		"ea7a",
		"Client0~CommonCode0~Order0~OrderAck0~OrderAmount0~OrderAnalysis0~ProductCode0~Purchase0~PurchaseTax0~aac84a3b",
		"Client0~CommonCode0~Order0~OrderAck0~OrderAmount0~OrderAnalysis0~ProductCode0~Purchase0~PurchaseTax0~c2760ff0",
		"ShipCode0~view-Buyer-Order-DetailForm-vue~view-Buyer-Purchase-DetailForm-vue~view-Buyer-PurchaseTax-~73523415",
		"view-Buyer-Purchase-DetailForm-vue"
	],
	"./Buyer/Purchase/Item.vue": [
		"a60b",
		"Client0~CommonCode0~Order0~OrderAck0~OrderAmount0~OrderAnalysis0~ProductCode0~Purchase0~PurchaseTax0~aac84a3b",
		"Client0~CommonCode0~Order0~OrderAck0~OrderAmount0~OrderAnalysis0~ProductCode0~Purchase0~PurchaseTax0~c2760ff0",
		"view-Code-Client-DetailForm-vue",
		"Client0",
		"view-Buyer-Purchase-Item-vue"
	],
	"./Buyer/Purchase/List.vue": [
		"5d32",
		"view-Buyer-Order-List-vue~view-Buyer-Purchase-List-vue~view-Buyer-PurchaseTax-List-vue~view-Buyer-Qu~bde1fb3b",
		"view-Buyer-Purchase-List-vue"
	],
	"./Buyer/Purchase/Main.vue": [
		"e577",
		"Client0~CommonCode0~Order0~OrderAck0~OrderAmount0~OrderAnalysis0~ProductCode0~Purchase0~PurchaseTax0~aac84a3b",
		"Client0~CommonCode0~Order0~OrderAck0~OrderAmount0~OrderAnalysis0~ProductCode0~Purchase0~PurchaseTax0~c2760ff0",
		"view-Code-Client-DetailForm-vue",
		"Client0",
		"Purchase0"
	],
	"./Buyer/Purchase/SearchPanel.vue": [
		"5d6f",
		"Client0~CommonCode0~Order0~OrderAck0~OrderAmount0~OrderAnalysis0~ProductCode0~Purchase0~PurchaseTax0~aac84a3b",
		"view-Buyer-Purchase-SearchPanel-vue"
	],
	"./Buyer/PurchaseTax/Action.vue": [
		"7268",
		"view-Buyer-PurchaseTax-Action-vue"
	],
	"./Buyer/PurchaseTax/Detail.vue": [
		"d3d6b",
		"Client0~CommonCode0~Order0~OrderAck0~OrderAmount0~OrderAnalysis0~ProductCode0~Purchase0~PurchaseTax0~aac84a3b",
		"Client0~CommonCode0~Order0~OrderAck0~OrderAmount0~OrderAnalysis0~ProductCode0~Purchase0~PurchaseTax0~c2760ff0",
		"view-Code-Client-DetailForm-vue",
		"Client0",
		"view-Buyer-PurchaseTax-Detail-vue"
	],
	"./Buyer/PurchaseTax/DetailForm.vue": [
		"f61f",
		"Client0~CommonCode0~Order0~OrderAck0~OrderAmount0~OrderAnalysis0~ProductCode0~Purchase0~PurchaseTax0~aac84a3b",
		"Client0~CommonCode0~Order0~OrderAck0~OrderAmount0~OrderAnalysis0~ProductCode0~Purchase0~PurchaseTax0~c2760ff0",
		"ShipCode0~view-Buyer-Order-DetailForm-vue~view-Buyer-Purchase-DetailForm-vue~view-Buyer-PurchaseTax-~73523415",
		"view-Buyer-PurchaseTax-DetailForm-vue"
	],
	"./Buyer/PurchaseTax/Item.vue": [
		"d0b5",
		"Client0~CommonCode0~Order0~OrderAck0~OrderAmount0~OrderAnalysis0~ProductCode0~Purchase0~PurchaseTax0~aac84a3b",
		"Client0~CommonCode0~Order0~OrderAck0~OrderAmount0~OrderAnalysis0~ProductCode0~Purchase0~PurchaseTax0~c2760ff0",
		"view-Code-Client-DetailForm-vue",
		"Client0",
		"view-Buyer-PurchaseTax-Item-vue"
	],
	"./Buyer/PurchaseTax/List.vue": [
		"c7c0",
		"view-Buyer-Order-List-vue~view-Buyer-Purchase-List-vue~view-Buyer-PurchaseTax-List-vue~view-Buyer-Qu~bde1fb3b",
		"view-Buyer-PurchaseTax-List-vue"
	],
	"./Buyer/PurchaseTax/Main.vue": [
		"3f97",
		"Client0~CommonCode0~Order0~OrderAck0~OrderAmount0~OrderAnalysis0~ProductCode0~Purchase0~PurchaseTax0~aac84a3b",
		"Client0~CommonCode0~Order0~OrderAck0~OrderAmount0~OrderAnalysis0~ProductCode0~Purchase0~PurchaseTax0~c2760ff0",
		"view-Code-Client-DetailForm-vue",
		"Client0",
		"PurchaseTax0"
	],
	"./Buyer/PurchaseTax/SearchPanel.vue": [
		"69ad",
		"Client0~CommonCode0~Order0~OrderAck0~OrderAmount0~OrderAnalysis0~ProductCode0~Purchase0~PurchaseTax0~aac84a3b",
		"view-Buyer-PurchaseTax-SearchPanel-vue"
	],
	"./Buyer/QuotationBox/Action.vue": [
		"1966",
		"view-Buyer-QuotationBox-Action-vue"
	],
	"./Buyer/QuotationBox/Detail.vue": [
		"c34f",
		"Client0~CommonCode0~Order0~OrderAck0~OrderAmount0~OrderAnalysis0~ProductCode0~Purchase0~PurchaseTax0~aac84a3b",
		"Client0~CommonCode0~Order0~OrderAck0~OrderAmount0~OrderAnalysis0~ProductCode0~Purchase0~PurchaseTax0~c2760ff0",
		"view-Code-Client-DetailForm-vue",
		"Client0",
		"view-Buyer-QuotationBox-Detail-vue"
	],
	"./Buyer/QuotationBox/DetailForm.vue": [
		"2cb5",
		"Client0~CommonCode0~Order0~OrderAck0~OrderAmount0~OrderAnalysis0~ProductCode0~Purchase0~PurchaseTax0~aac84a3b",
		"Client0~CommonCode0~Order0~OrderAck0~OrderAmount0~OrderAnalysis0~ProductCode0~Purchase0~PurchaseTax0~c2760ff0",
		"ShipCode0~view-Buyer-Order-DetailForm-vue~view-Buyer-Purchase-DetailForm-vue~view-Buyer-PurchaseTax-~73523415",
		"view-Buyer-QuotationBox-DetailForm-vue"
	],
	"./Buyer/QuotationBox/Item.vue": [
		"16eb",
		"Client0~CommonCode0~Order0~OrderAck0~OrderAmount0~OrderAnalysis0~ProductCode0~Purchase0~PurchaseTax0~aac84a3b",
		"Client0~CommonCode0~Order0~OrderAck0~OrderAmount0~OrderAnalysis0~ProductCode0~Purchase0~PurchaseTax0~c2760ff0",
		"view-Code-Client-DetailForm-vue",
		"Client0",
		"view-Buyer-QuotationBox-Item-vue"
	],
	"./Buyer/QuotationBox/List.vue": [
		"075c",
		"view-Buyer-Order-List-vue~view-Buyer-Purchase-List-vue~view-Buyer-PurchaseTax-List-vue~view-Buyer-Qu~bde1fb3b",
		"view-Buyer-QuotationBox-List-vue"
	],
	"./Buyer/QuotationBox/Main.vue": [
		"cc78",
		"Client0~CommonCode0~Order0~OrderAck0~OrderAmount0~OrderAnalysis0~ProductCode0~Purchase0~PurchaseTax0~aac84a3b",
		"Client0~CommonCode0~Order0~OrderAck0~OrderAmount0~OrderAnalysis0~ProductCode0~Purchase0~PurchaseTax0~c2760ff0",
		"view-Code-Client-DetailForm-vue",
		"Client0",
		"QuotationBox0"
	],
	"./Buyer/QuotationBox/SearchPanel.vue": [
		"cccf",
		"Client0~CommonCode0~Order0~OrderAck0~OrderAmount0~OrderAnalysis0~ProductCode0~Purchase0~PurchaseTax0~aac84a3b",
		"view-Buyer-QuotationBox-SearchPanel-vue"
	],
	"./Buyer/Requisition/Action.vue": [
		"d051",
		"view-Buyer-Requisition-Action-vue"
	],
	"./Buyer/Requisition/Detail.vue": [
		"f311",
		"Client0~CommonCode0~Order0~OrderAck0~OrderAmount0~OrderAnalysis0~ProductCode0~Purchase0~PurchaseTax0~aac84a3b",
		"Client0~CommonCode0~Order0~OrderAck0~OrderAmount0~OrderAnalysis0~ProductCode0~Purchase0~PurchaseTax0~c2760ff0",
		"view-Code-Client-DetailForm-vue",
		"Client0",
		"view-Buyer-Requisition-Detail-vue"
	],
	"./Buyer/Requisition/DetailForm.vue": [
		"0bf2",
		"Client0~CommonCode0~Order0~OrderAck0~OrderAmount0~OrderAnalysis0~ProductCode0~Purchase0~PurchaseTax0~aac84a3b",
		"Client0~CommonCode0~Order0~OrderAck0~OrderAmount0~OrderAnalysis0~ProductCode0~Purchase0~PurchaseTax0~c2760ff0",
		"ShipCode0~view-Buyer-Order-DetailForm-vue~view-Buyer-Purchase-DetailForm-vue~view-Buyer-PurchaseTax-~73523415",
		"view-Buyer-Requisition-DetailForm-vue"
	],
	"./Buyer/Requisition/Item.vue": [
		"296c",
		"Client0~CommonCode0~Order0~OrderAck0~OrderAmount0~OrderAnalysis0~ProductCode0~Purchase0~PurchaseTax0~aac84a3b",
		"Client0~CommonCode0~Order0~OrderAck0~OrderAmount0~OrderAnalysis0~ProductCode0~Purchase0~PurchaseTax0~c2760ff0",
		"view-Code-Client-DetailForm-vue",
		"Client0",
		"view-Buyer-Requisition-Item-vue"
	],
	"./Buyer/Requisition/List.vue": [
		"ad45",
		"view-Buyer-Requisition-List-vue"
	],
	"./Buyer/Requisition/Main.vue": [
		"bfb6",
		"Client0~CommonCode0~Order0~OrderAck0~OrderAmount0~OrderAnalysis0~ProductCode0~Purchase0~PurchaseTax0~aac84a3b",
		"Client0~CommonCode0~Order0~OrderAck0~OrderAmount0~OrderAnalysis0~ProductCode0~Purchase0~PurchaseTax0~c2760ff0",
		"view-Code-Client-DetailForm-vue",
		"Client0",
		"Requisition0"
	],
	"./Buyer/Requisition/SearchPanel.vue": [
		"41f1",
		"Client0~CommonCode0~Order0~OrderAck0~OrderAmount0~OrderAnalysis0~ProductCode0~Purchase0~PurchaseTax0~aac84a3b",
		"view-Buyer-Requisition-SearchPanel-vue"
	],
	"./Buyer/Rfq/Action.vue": [
		"c935",
		"view-Buyer-Rfq-Action-vue"
	],
	"./Buyer/Rfq/Detail.vue": [
		"facd",
		"Client0~CommonCode0~Order0~OrderAck0~OrderAmount0~OrderAnalysis0~ProductCode0~Purchase0~PurchaseTax0~aac84a3b",
		"Client0~CommonCode0~Order0~OrderAck0~OrderAmount0~OrderAnalysis0~ProductCode0~Purchase0~PurchaseTax0~c2760ff0",
		"view-Code-Client-DetailForm-vue",
		"Client0",
		"view-Buyer-Rfq-Detail-vue"
	],
	"./Buyer/Rfq/DetailForm.vue": [
		"494d",
		"Client0~CommonCode0~Order0~OrderAck0~OrderAmount0~OrderAnalysis0~ProductCode0~Purchase0~PurchaseTax0~aac84a3b",
		"Client0~CommonCode0~Order0~OrderAck0~OrderAmount0~OrderAnalysis0~ProductCode0~Purchase0~PurchaseTax0~c2760ff0",
		"ShipCode0~view-Buyer-Order-DetailForm-vue~view-Buyer-Purchase-DetailForm-vue~view-Buyer-PurchaseTax-~73523415",
		"view-Buyer-Rfq-DetailForm-vue"
	],
	"./Buyer/Rfq/Item.vue": [
		"cc5b",
		"Client0~CommonCode0~Order0~OrderAck0~OrderAmount0~OrderAnalysis0~ProductCode0~Purchase0~PurchaseTax0~aac84a3b",
		"Client0~CommonCode0~Order0~OrderAck0~OrderAmount0~OrderAnalysis0~ProductCode0~Purchase0~PurchaseTax0~c2760ff0",
		"view-Code-Client-DetailForm-vue",
		"Client0",
		"view-Buyer-Rfq-Item-vue"
	],
	"./Buyer/Rfq/ItemRFQ.vue": [
		"c16d",
		"Client0~CommonCode0~Order0~OrderAck0~OrderAmount0~OrderAnalysis0~ProductCode0~Purchase0~PurchaseTax0~aac84a3b",
		"Client0~CommonCode0~Order0~OrderAck0~OrderAmount0~OrderAnalysis0~ProductCode0~Purchase0~PurchaseTax0~c2760ff0",
		"view-Code-Client-DetailForm-vue",
		"Client0",
		"view-Buyer-Rfq-ItemRFQ-vue"
	],
	"./Buyer/Rfq/ItemRFQResult.vue": [
		"c623",
		"Client0~CommonCode0~Order0~OrderAck0~OrderAmount0~OrderAnalysis0~ProductCode0~Purchase0~PurchaseTax0~aac84a3b",
		"Client0~CommonCode0~Order0~OrderAck0~OrderAmount0~OrderAnalysis0~ProductCode0~Purchase0~PurchaseTax0~c2760ff0",
		"view-Code-Client-DetailForm-vue",
		"Client0",
		"view-Buyer-Rfq-ItemRFQResult-vue"
	],
	"./Buyer/Rfq/List.vue": [
		"ff3a",
		"view-Buyer-Order-List-vue~view-Buyer-Purchase-List-vue~view-Buyer-PurchaseTax-List-vue~view-Buyer-Qu~bde1fb3b",
		"view-Buyer-Rfq-List-vue"
	],
	"./Buyer/Rfq/Main.vue": [
		"d550",
		"Client0~CommonCode0~Order0~OrderAck0~OrderAmount0~OrderAnalysis0~ProductCode0~Purchase0~PurchaseTax0~aac84a3b",
		"Client0~CommonCode0~Order0~OrderAck0~OrderAmount0~OrderAnalysis0~ProductCode0~Purchase0~PurchaseTax0~c2760ff0",
		"view-Code-Client-DetailForm-vue",
		"Client0",
		"Rfq0"
	],
	"./Buyer/Rfq/SearchPanel.vue": [
		"8bef",
		"Client0~CommonCode0~Order0~OrderAck0~OrderAmount0~OrderAnalysis0~ProductCode0~Purchase0~PurchaseTax0~aac84a3b",
		"view-Buyer-Rfq-SearchPanel-vue"
	],
	"./Buyer/Test/Action.vue": [
		"93b5",
		"view-Buyer-Test-Action-vue"
	],
	"./Buyer/Test/Detail.vue": [
		"c25b",
		"Client0~CommonCode0~Order0~OrderAck0~OrderAmount0~OrderAnalysis0~ProductCode0~Purchase0~PurchaseTax0~aac84a3b",
		"Client0~CommonCode0~Order0~OrderAck0~OrderAmount0~OrderAnalysis0~ProductCode0~Purchase0~PurchaseTax0~c2760ff0",
		"view-Code-Client-DetailForm-vue",
		"Client0",
		"view-Buyer-Test-Detail-vue"
	],
	"./Buyer/Test/DetailForm.vue": [
		"79a5",
		"Client0~CommonCode0~Order0~OrderAck0~OrderAmount0~OrderAnalysis0~ProductCode0~Purchase0~PurchaseTax0~aac84a3b",
		"Client0~CommonCode0~Order0~OrderAck0~OrderAmount0~OrderAnalysis0~ProductCode0~Purchase0~PurchaseTax0~c2760ff0",
		"ShipCode0~view-Buyer-Order-DetailForm-vue~view-Buyer-Purchase-DetailForm-vue~view-Buyer-PurchaseTax-~73523415",
		"view-Buyer-Test-DetailForm-vue"
	],
	"./Buyer/Test/Item.vue": [
		"adb4",
		"Client0~CommonCode0~Order0~OrderAck0~OrderAmount0~OrderAnalysis0~ProductCode0~Purchase0~PurchaseTax0~aac84a3b",
		"Client0~CommonCode0~Order0~OrderAck0~OrderAmount0~OrderAnalysis0~ProductCode0~Purchase0~PurchaseTax0~c2760ff0",
		"view-Code-Client-DetailForm-vue",
		"Client0",
		"view-Buyer-Test-Item-vue"
	],
	"./Buyer/Test/List.vue": [
		"f44d",
		"view-Buyer-Test-List-vue"
	],
	"./Buyer/Test/Main.vue": [
		"81bd",
		"Client0~CommonCode0~Order0~OrderAck0~OrderAmount0~OrderAnalysis0~ProductCode0~Purchase0~PurchaseTax0~aac84a3b",
		"Client0~CommonCode0~Order0~OrderAck0~OrderAmount0~OrderAnalysis0~ProductCode0~Purchase0~PurchaseTax0~c2760ff0",
		"view-Code-Client-DetailForm-vue",
		"Client0",
		"Test0"
	],
	"./Buyer/Test/SearchPanel.vue": [
		"1427",
		"view-Buyer-Test-SearchPanel-vue"
	],
	"./Code/Client/Action.vue": [
		"7d52",
		"Client0~CommonCode0~Order0~OrderAck0~OrderAmount0~OrderAnalysis0~ProductCode0~Purchase0~PurchaseTax0~c2760ff0",
		"view-Code-Client-Action-vue"
	],
	"./Code/Client/DetailForm.vue": [
		"63ef",
		"Client0~CommonCode0~Order0~OrderAck0~OrderAmount0~OrderAnalysis0~ProductCode0~Purchase0~PurchaseTax0~aac84a3b",
		"view-Code-Client-DetailForm-vue"
	],
	"./Code/Client/List.vue": [
		"8b94",
		"Client0~CommonCode0~Order0~OrderAck0~OrderAmount0~OrderAnalysis0~ProductCode0~Purchase0~PurchaseTax0~aac84a3b",
		"view-Code-Client-List-vue"
	],
	"./Code/Client/Main.vue": [
		"fb87",
		"Client0~CommonCode0~Order0~OrderAck0~OrderAmount0~OrderAnalysis0~ProductCode0~Purchase0~PurchaseTax0~aac84a3b",
		"Client0~CommonCode0~Order0~OrderAck0~OrderAmount0~OrderAnalysis0~ProductCode0~Purchase0~PurchaseTax0~c2760ff0",
		"view-Code-Client-DetailForm-vue",
		"Client0"
	],
	"./Code/Client/SearchPanel.vue": [
		"3c59",
		"Client0~CommonCode0~Order0~OrderAck0~OrderAmount0~OrderAnalysis0~ProductCode0~Purchase0~PurchaseTax0~aac84a3b",
		"Client0~CommonCode0~Order0~OrderAck0~OrderAmount0~OrderAnalysis0~ProductCode0~Purchase0~PurchaseTax0~c2760ff0",
		"view-Code-Client-SearchPanel-vue"
	],
	"./Code/CommonCode/Action.vue": [
		"6b52",
		"Client0~CommonCode0~Order0~OrderAck0~OrderAmount0~OrderAnalysis0~ProductCode0~Purchase0~PurchaseTax0~aac84a3b",
		"Client0~CommonCode0~Order0~OrderAck0~OrderAmount0~OrderAnalysis0~ProductCode0~Purchase0~PurchaseTax0~c2760ff0",
		"view-Code-CommonCode-Action-vue"
	],
	"./Code/CommonCode/DetailForm.vue": [
		"9ea6",
		"view-Code-CommonCode-DetailForm-vue"
	],
	"./Code/CommonCode/List.vue": [
		"94e1",
		"Client0~CommonCode0~Order0~OrderAck0~OrderAmount0~OrderAnalysis0~ProductCode0~Purchase0~PurchaseTax0~aac84a3b",
		"view-Code-CommonCode-List-vue"
	],
	"./Code/CommonCode/Main.vue": [
		"2f0f",
		"Client0~CommonCode0~Order0~OrderAck0~OrderAmount0~OrderAnalysis0~ProductCode0~Purchase0~PurchaseTax0~aac84a3b",
		"Client0~CommonCode0~Order0~OrderAck0~OrderAmount0~OrderAnalysis0~ProductCode0~Purchase0~PurchaseTax0~c2760ff0",
		"CommonCode0"
	],
	"./Code/CommonCode/SearchPanel.vue": [
		"963a",
		"Client0~CommonCode0~Order0~OrderAck0~OrderAmount0~OrderAnalysis0~ProductCode0~Purchase0~PurchaseTax0~aac84a3b",
		"Client0~CommonCode0~Order0~OrderAck0~OrderAmount0~OrderAnalysis0~ProductCode0~Purchase0~PurchaseTax0~c2760ff0",
		"view-Code-CommonCode-SearchPanel-vue"
	],
	"./Code/PostCode.vue": [
		"9d25",
		"view-Code-PostCode-vue"
	],
	"./Code/ProductCode/Action.vue": [
		"eeea",
		"Client0~CommonCode0~Order0~OrderAck0~OrderAmount0~OrderAnalysis0~ProductCode0~Purchase0~PurchaseTax0~c2760ff0",
		"view-Code-ProductCode-Action-vue"
	],
	"./Code/ProductCode/DetailForm.vue": [
		"3ea8",
		"Client0~CommonCode0~Order0~OrderAck0~OrderAmount0~OrderAnalysis0~ProductCode0~Purchase0~PurchaseTax0~aac84a3b",
		"Client0~CommonCode0~Order0~OrderAck0~OrderAmount0~OrderAnalysis0~ProductCode0~Purchase0~PurchaseTax0~c2760ff0",
		"view-Code-Client-DetailForm-vue",
		"Client0",
		"ProductCode0"
	],
	"./Code/ProductCode/Left.vue": [
		"7241",
		"Client0~CommonCode0~Order0~OrderAck0~OrderAmount0~OrderAnalysis0~ProductCode0~Purchase0~PurchaseTax0~aac84a3b",
		"view-Code-ProductCode-Left-vue"
	],
	"./Code/ProductCode/List.vue": [
		"10b7",
		"view-Code-ProductCode-List-vue"
	],
	"./Code/ProductCode/Main.vue": [
		"937a",
		"Client0~CommonCode0~Order0~OrderAck0~OrderAmount0~OrderAnalysis0~ProductCode0~Purchase0~PurchaseTax0~aac84a3b",
		"Client0~CommonCode0~Order0~OrderAck0~OrderAmount0~OrderAnalysis0~ProductCode0~Purchase0~PurchaseTax0~c2760ff0",
		"view-Code-Client-DetailForm-vue",
		"Client0",
		"ProductCode0"
	],
	"./Code/ProductCode/SearchPanel.vue": [
		"c987",
		"Client0~CommonCode0~Order0~OrderAck0~OrderAmount0~OrderAnalysis0~ProductCode0~Purchase0~PurchaseTax0~aac84a3b",
		"Client0~CommonCode0~Order0~OrderAck0~OrderAmount0~OrderAnalysis0~ProductCode0~Purchase0~PurchaseTax0~c2760ff0",
		"view-Code-ProductCode-SearchPanel-vue"
	],
	"./Code/ShipCode/Action.vue": [
		"b9fb",
		"view-Code-ShipCode-Action-vue"
	],
	"./Code/ShipCode/DetailForm.vue": [
		"38ac",
		"view-Code-ShipCode-DetailForm-vue"
	],
	"./Code/ShipCode/List.vue": [
		"91a3",
		"view-Code-ShipCode-List-vue"
	],
	"./Code/ShipCode/Main.vue": [
		"6fbb",
		"Client0~CommonCode0~Order0~OrderAck0~OrderAmount0~OrderAnalysis0~ProductCode0~Purchase0~PurchaseTax0~aac84a3b",
		"Client0~CommonCode0~Order0~OrderAck0~OrderAmount0~OrderAnalysis0~ProductCode0~Purchase0~PurchaseTax0~c2760ff0",
		"ShipCode0~view-Buyer-Order-DetailForm-vue~view-Buyer-Purchase-DetailForm-vue~view-Buyer-PurchaseTax-~73523415",
		"ShipCode0"
	],
	"./Code/ShipCode/SearchPanel.vue": [
		"4c15",
		"Client0~CommonCode0~Order0~OrderAck0~OrderAmount0~OrderAnalysis0~ProductCode0~Purchase0~PurchaseTax0~c2760ff0",
		"view-Code-ShipCode-SearchPanel-vue"
	],
	"./Code/modal.vue": [
		"d8c2",
		"view-Code-modal-vue"
	],
	"./Common/AttachFiles.vue": [
		"667f",
		"view-Common-AttachFiles-vue"
	],
	"./Common/Modal/ApiExplorer.vue": [
		"9761"
	],
	"./Common/Modal/ExcelUpload.vue": [
		"ed41",
		"view-Buyer-Order-List-vue~view-Buyer-Purchase-List-vue~view-Buyer-PurchaseTax-List-vue~view-Buyer-Qu~bde1fb3b",
		"view-Common-Modal-ExcelUpload-vue"
	],
	"./Common/Modal/GridConfig.vue": [
		"565e"
	],
	"./Common/Modal/SendModal.vue": [
		"6fd4",
		"view-Common-Modal-SendModal-vue"
	],
	"./Home.vue": [
		"bb51",
		"Home0"
	],
	"./HomeSTOM.vue": [
		"93c4",
		"HomeSTOM0"
	],
	"./Statistics/OrderAmount/Action.vue": [
		"d63ba",
		"view-Statistics-OrderAmount-Action-vue"
	],
	"./Statistics/OrderAmount/Detail.vue": [
		"00bc",
		"Client0~CommonCode0~Order0~OrderAck0~OrderAmount0~OrderAnalysis0~ProductCode0~Purchase0~PurchaseTax0~aac84a3b",
		"Client0~CommonCode0~Order0~OrderAck0~OrderAmount0~OrderAnalysis0~ProductCode0~Purchase0~PurchaseTax0~c2760ff0",
		"view-Code-Client-DetailForm-vue",
		"Client0",
		"view-Statistics-OrderAmount-Detail-vue"
	],
	"./Statistics/OrderAmount/DetailForm.vue": [
		"17df",
		"Client0~CommonCode0~Order0~OrderAck0~OrderAmount0~OrderAnalysis0~ProductCode0~Purchase0~PurchaseTax0~aac84a3b",
		"Client0~CommonCode0~Order0~OrderAck0~OrderAmount0~OrderAnalysis0~ProductCode0~Purchase0~PurchaseTax0~c2760ff0",
		"ShipCode0~view-Buyer-Order-DetailForm-vue~view-Buyer-Purchase-DetailForm-vue~view-Buyer-PurchaseTax-~73523415",
		"view-Statistics-OrderAmount-DetailForm-vue"
	],
	"./Statistics/OrderAmount/Item.vue": [
		"1d5c",
		"Client0~CommonCode0~Order0~OrderAck0~OrderAmount0~OrderAnalysis0~ProductCode0~Purchase0~PurchaseTax0~aac84a3b",
		"Client0~CommonCode0~Order0~OrderAck0~OrderAmount0~OrderAnalysis0~ProductCode0~Purchase0~PurchaseTax0~c2760ff0",
		"view-Code-Client-DetailForm-vue",
		"Client0",
		"view-Statistics-OrderAmount-Item-vue"
	],
	"./Statistics/OrderAmount/List.vue": [
		"dbce",
		"view-Buyer-Order-List-vue~view-Buyer-Purchase-List-vue~view-Buyer-PurchaseTax-List-vue~view-Buyer-Qu~bde1fb3b",
		"view-Statistics-OrderAmount-List-vue"
	],
	"./Statistics/OrderAmount/Main.vue": [
		"3f36",
		"Client0~CommonCode0~Order0~OrderAck0~OrderAmount0~OrderAnalysis0~ProductCode0~Purchase0~PurchaseTax0~aac84a3b",
		"Client0~CommonCode0~Order0~OrderAck0~OrderAmount0~OrderAnalysis0~ProductCode0~Purchase0~PurchaseTax0~c2760ff0",
		"view-Code-Client-DetailForm-vue",
		"Client0",
		"OrderAmount0"
	],
	"./Statistics/OrderAmount/SearchPanel.vue": [
		"d3c2",
		"Client0~CommonCode0~Order0~OrderAck0~OrderAmount0~OrderAnalysis0~ProductCode0~Purchase0~PurchaseTax0~aac84a3b",
		"view-Statistics-OrderAmount-SearchPanel-vue"
	],
	"./Statistics/OrderAnalysis/Action.vue": [
		"793f",
		"view-Statistics-OrderAnalysis-Action-vue"
	],
	"./Statistics/OrderAnalysis/Detail.vue": [
		"0f16",
		"Client0~CommonCode0~Order0~OrderAck0~OrderAmount0~OrderAnalysis0~ProductCode0~Purchase0~PurchaseTax0~aac84a3b",
		"Client0~CommonCode0~Order0~OrderAck0~OrderAmount0~OrderAnalysis0~ProductCode0~Purchase0~PurchaseTax0~c2760ff0",
		"view-Code-Client-DetailForm-vue",
		"Client0",
		"view-Statistics-OrderAnalysis-Detail-vue"
	],
	"./Statistics/OrderAnalysis/DetailForm.vue": [
		"51af",
		"Client0~CommonCode0~Order0~OrderAck0~OrderAmount0~OrderAnalysis0~ProductCode0~Purchase0~PurchaseTax0~aac84a3b",
		"Client0~CommonCode0~Order0~OrderAck0~OrderAmount0~OrderAnalysis0~ProductCode0~Purchase0~PurchaseTax0~c2760ff0",
		"ShipCode0~view-Buyer-Order-DetailForm-vue~view-Buyer-Purchase-DetailForm-vue~view-Buyer-PurchaseTax-~73523415",
		"view-Statistics-OrderAnalysis-DetailForm-vue"
	],
	"./Statistics/OrderAnalysis/Item.vue": [
		"6509",
		"Client0~CommonCode0~Order0~OrderAck0~OrderAmount0~OrderAnalysis0~ProductCode0~Purchase0~PurchaseTax0~aac84a3b",
		"Client0~CommonCode0~Order0~OrderAck0~OrderAmount0~OrderAnalysis0~ProductCode0~Purchase0~PurchaseTax0~c2760ff0",
		"view-Code-Client-DetailForm-vue",
		"Client0",
		"view-Statistics-OrderAnalysis-Item-vue"
	],
	"./Statistics/OrderAnalysis/List.vue": [
		"d9c7",
		"view-Buyer-Order-List-vue~view-Buyer-Purchase-List-vue~view-Buyer-PurchaseTax-List-vue~view-Buyer-Qu~bde1fb3b",
		"view-Statistics-OrderAnalysis-List-vue"
	],
	"./Statistics/OrderAnalysis/Main.vue": [
		"7ce8",
		"Client0~CommonCode0~Order0~OrderAck0~OrderAmount0~OrderAnalysis0~ProductCode0~Purchase0~PurchaseTax0~aac84a3b",
		"Client0~CommonCode0~Order0~OrderAck0~OrderAmount0~OrderAnalysis0~ProductCode0~Purchase0~PurchaseTax0~c2760ff0",
		"view-Code-Client-DetailForm-vue",
		"Client0",
		"OrderAnalysis0"
	],
	"./Statistics/OrderAnalysis/SearchPanel.vue": [
		"1517",
		"Client0~CommonCode0~Order0~OrderAck0~OrderAmount0~OrderAnalysis0~ProductCode0~Purchase0~PurchaseTax0~aac84a3b",
		"view-Statistics-OrderAnalysis-SearchPanel-vue"
	],
	"./Statistics/QuotationPerformance/Action.vue": [
		"78df",
		"view-Statistics-QuotationPerformance-Action-vue"
	],
	"./Statistics/QuotationPerformance/Detail.vue": [
		"d832",
		"Client0~CommonCode0~Order0~OrderAck0~OrderAmount0~OrderAnalysis0~ProductCode0~Purchase0~PurchaseTax0~aac84a3b",
		"Client0~CommonCode0~Order0~OrderAck0~OrderAmount0~OrderAnalysis0~ProductCode0~Purchase0~PurchaseTax0~c2760ff0",
		"view-Code-Client-DetailForm-vue",
		"Client0",
		"view-Statistics-QuotationPerformance-Detail-vue"
	],
	"./Statistics/QuotationPerformance/DetailForm.vue": [
		"4e0b",
		"Client0~CommonCode0~Order0~OrderAck0~OrderAmount0~OrderAnalysis0~ProductCode0~Purchase0~PurchaseTax0~aac84a3b",
		"Client0~CommonCode0~Order0~OrderAck0~OrderAmount0~OrderAnalysis0~ProductCode0~Purchase0~PurchaseTax0~c2760ff0",
		"ShipCode0~view-Buyer-Order-DetailForm-vue~view-Buyer-Purchase-DetailForm-vue~view-Buyer-PurchaseTax-~73523415",
		"view-Statistics-QuotationPerformance-DetailForm-vue"
	],
	"./Statistics/QuotationPerformance/Item.vue": [
		"eece",
		"Client0~CommonCode0~Order0~OrderAck0~OrderAmount0~OrderAnalysis0~ProductCode0~Purchase0~PurchaseTax0~aac84a3b",
		"Client0~CommonCode0~Order0~OrderAck0~OrderAmount0~OrderAnalysis0~ProductCode0~Purchase0~PurchaseTax0~c2760ff0",
		"view-Code-Client-DetailForm-vue",
		"Client0",
		"view-Statistics-QuotationPerformance-Item-vue"
	],
	"./Statistics/QuotationPerformance/List.vue": [
		"68e8",
		"view-Buyer-Order-List-vue~view-Buyer-Purchase-List-vue~view-Buyer-PurchaseTax-List-vue~view-Buyer-Qu~bde1fb3b",
		"view-Statistics-QuotationPerformance-List-vue"
	],
	"./Statistics/QuotationPerformance/Main.vue": [
		"2513",
		"Client0~CommonCode0~Order0~OrderAck0~OrderAmount0~OrderAnalysis0~ProductCode0~Purchase0~PurchaseTax0~aac84a3b",
		"Client0~CommonCode0~Order0~OrderAck0~OrderAmount0~OrderAnalysis0~ProductCode0~Purchase0~PurchaseTax0~c2760ff0",
		"view-Code-Client-DetailForm-vue",
		"Client0",
		"QuotationPerformance0"
	],
	"./Statistics/QuotationPerformance/SearchPanel.vue": [
		"4df1",
		"Client0~CommonCode0~Order0~OrderAck0~OrderAmount0~OrderAnalysis0~ProductCode0~Purchase0~PurchaseTax0~aac84a3b",
		"view-Statistics-QuotationPerformance-SearchPanel-vue"
	],
	"./Statistics/SaleStatus/Action.vue": [
		"0ebc",
		"view-Statistics-SaleStatus-Action-vue"
	],
	"./Statistics/SaleStatus/Detail.vue": [
		"3a98",
		"Client0~CommonCode0~Order0~OrderAck0~OrderAmount0~OrderAnalysis0~ProductCode0~Purchase0~PurchaseTax0~aac84a3b",
		"Client0~CommonCode0~Order0~OrderAck0~OrderAmount0~OrderAnalysis0~ProductCode0~Purchase0~PurchaseTax0~c2760ff0",
		"view-Code-Client-DetailForm-vue",
		"Client0",
		"view-Statistics-SaleStatus-Detail-vue"
	],
	"./Statistics/SaleStatus/DetailForm.vue": [
		"55f5",
		"Client0~CommonCode0~Order0~OrderAck0~OrderAmount0~OrderAnalysis0~ProductCode0~Purchase0~PurchaseTax0~aac84a3b",
		"Client0~CommonCode0~Order0~OrderAck0~OrderAmount0~OrderAnalysis0~ProductCode0~Purchase0~PurchaseTax0~c2760ff0",
		"ShipCode0~view-Buyer-Order-DetailForm-vue~view-Buyer-Purchase-DetailForm-vue~view-Buyer-PurchaseTax-~73523415",
		"view-Statistics-SaleStatus-DetailForm-vue"
	],
	"./Statistics/SaleStatus/Item.vue": [
		"855e",
		"Client0~CommonCode0~Order0~OrderAck0~OrderAmount0~OrderAnalysis0~ProductCode0~Purchase0~PurchaseTax0~aac84a3b",
		"Client0~CommonCode0~Order0~OrderAck0~OrderAmount0~OrderAnalysis0~ProductCode0~Purchase0~PurchaseTax0~c2760ff0",
		"view-Code-Client-DetailForm-vue",
		"Client0",
		"view-Statistics-SaleStatus-Item-vue"
	],
	"./Statistics/SaleStatus/List.vue": [
		"1b5f",
		"view-Buyer-Order-List-vue~view-Buyer-Purchase-List-vue~view-Buyer-PurchaseTax-List-vue~view-Buyer-Qu~bde1fb3b",
		"view-Statistics-SaleStatus-List-vue"
	],
	"./Statistics/SaleStatus/Main.vue": [
		"f08c",
		"Client0~CommonCode0~Order0~OrderAck0~OrderAmount0~OrderAnalysis0~ProductCode0~Purchase0~PurchaseTax0~aac84a3b",
		"Client0~CommonCode0~Order0~OrderAck0~OrderAmount0~OrderAnalysis0~ProductCode0~Purchase0~PurchaseTax0~c2760ff0",
		"view-Code-Client-DetailForm-vue",
		"Client0",
		"SaleStatus0"
	],
	"./Statistics/SaleStatus/SearchPanel.vue": [
		"4f66",
		"Client0~CommonCode0~Order0~OrderAck0~OrderAmount0~OrderAnalysis0~ProductCode0~Purchase0~PurchaseTax0~aac84a3b",
		"view-Statistics-SaleStatus-SearchPanel-vue"
	],
	"./Statistics/SaleTotal/Action.vue": [
		"3a77",
		"view-Statistics-SaleTotal-Action-vue"
	],
	"./Statistics/SaleTotal/Detail.vue": [
		"9a98",
		"Client0~CommonCode0~Order0~OrderAck0~OrderAmount0~OrderAnalysis0~ProductCode0~Purchase0~PurchaseTax0~aac84a3b",
		"Client0~CommonCode0~Order0~OrderAck0~OrderAmount0~OrderAnalysis0~ProductCode0~Purchase0~PurchaseTax0~c2760ff0",
		"view-Code-Client-DetailForm-vue",
		"Client0",
		"view-Statistics-SaleTotal-Detail-vue"
	],
	"./Statistics/SaleTotal/DetailForm.vue": [
		"31b2",
		"Client0~CommonCode0~Order0~OrderAck0~OrderAmount0~OrderAnalysis0~ProductCode0~Purchase0~PurchaseTax0~aac84a3b",
		"Client0~CommonCode0~Order0~OrderAck0~OrderAmount0~OrderAnalysis0~ProductCode0~Purchase0~PurchaseTax0~c2760ff0",
		"ShipCode0~view-Buyer-Order-DetailForm-vue~view-Buyer-Purchase-DetailForm-vue~view-Buyer-PurchaseTax-~73523415",
		"view-Statistics-SaleTotal-DetailForm-vue"
	],
	"./Statistics/SaleTotal/Item.vue": [
		"2d3b",
		"Client0~CommonCode0~Order0~OrderAck0~OrderAmount0~OrderAnalysis0~ProductCode0~Purchase0~PurchaseTax0~aac84a3b",
		"Client0~CommonCode0~Order0~OrderAck0~OrderAmount0~OrderAnalysis0~ProductCode0~Purchase0~PurchaseTax0~c2760ff0",
		"view-Code-Client-DetailForm-vue",
		"Client0",
		"view-Statistics-SaleTotal-Item-vue"
	],
	"./Statistics/SaleTotal/List.vue": [
		"cc2b",
		"view-Buyer-Order-List-vue~view-Buyer-Purchase-List-vue~view-Buyer-PurchaseTax-List-vue~view-Buyer-Qu~bde1fb3b",
		"view-Statistics-SaleTotal-List-vue"
	],
	"./Statistics/SaleTotal/Main.vue": [
		"2586",
		"Client0~CommonCode0~Order0~OrderAck0~OrderAmount0~OrderAnalysis0~ProductCode0~Purchase0~PurchaseTax0~aac84a3b",
		"Client0~CommonCode0~Order0~OrderAck0~OrderAmount0~OrderAnalysis0~ProductCode0~Purchase0~PurchaseTax0~c2760ff0",
		"view-Code-Client-DetailForm-vue",
		"Client0",
		"SaleTotal0"
	],
	"./Statistics/SaleTotal/SearchPanel.vue": [
		"f382",
		"Client0~CommonCode0~Order0~OrderAck0~OrderAmount0~OrderAnalysis0~ProductCode0~Purchase0~PurchaseTax0~aac84a3b",
		"view-Statistics-SaleTotal-SearchPanel-vue"
	],
	"./Supplier/OrderAck/Action.vue": [
		"7da4",
		"view-Supplier-OrderAck-Action-vue"
	],
	"./Supplier/OrderAck/Detail.vue": [
		"b46a",
		"Client0~CommonCode0~Order0~OrderAck0~OrderAmount0~OrderAnalysis0~ProductCode0~Purchase0~PurchaseTax0~aac84a3b",
		"Client0~CommonCode0~Order0~OrderAck0~OrderAmount0~OrderAnalysis0~ProductCode0~Purchase0~PurchaseTax0~c2760ff0",
		"view-Code-Client-DetailForm-vue",
		"Client0",
		"view-Supplier-OrderAck-Detail-vue"
	],
	"./Supplier/OrderAck/DetailForm.vue": [
		"fc6b",
		"Client0~CommonCode0~Order0~OrderAck0~OrderAmount0~OrderAnalysis0~ProductCode0~Purchase0~PurchaseTax0~aac84a3b",
		"Client0~CommonCode0~Order0~OrderAck0~OrderAmount0~OrderAnalysis0~ProductCode0~Purchase0~PurchaseTax0~c2760ff0",
		"ShipCode0~view-Buyer-Order-DetailForm-vue~view-Buyer-Purchase-DetailForm-vue~view-Buyer-PurchaseTax-~73523415",
		"view-Supplier-OrderAck-DetailForm-vue"
	],
	"./Supplier/OrderAck/Item.vue": [
		"3ceb",
		"Client0~CommonCode0~Order0~OrderAck0~OrderAmount0~OrderAnalysis0~ProductCode0~Purchase0~PurchaseTax0~aac84a3b",
		"Client0~CommonCode0~Order0~OrderAck0~OrderAmount0~OrderAnalysis0~ProductCode0~Purchase0~PurchaseTax0~c2760ff0",
		"view-Code-Client-DetailForm-vue",
		"Client0",
		"view-Supplier-OrderAck-Item-vue"
	],
	"./Supplier/OrderAck/List.vue": [
		"e969",
		"view-Buyer-Order-List-vue~view-Buyer-Purchase-List-vue~view-Buyer-PurchaseTax-List-vue~view-Buyer-Qu~bde1fb3b",
		"view-Supplier-OrderAck-List-vue"
	],
	"./Supplier/OrderAck/Main.vue": [
		"687e",
		"Client0~CommonCode0~Order0~OrderAck0~OrderAmount0~OrderAnalysis0~ProductCode0~Purchase0~PurchaseTax0~aac84a3b",
		"Client0~CommonCode0~Order0~OrderAck0~OrderAmount0~OrderAnalysis0~ProductCode0~Purchase0~PurchaseTax0~c2760ff0",
		"view-Code-Client-DetailForm-vue",
		"Client0",
		"OrderAck0"
	],
	"./Supplier/OrderAck/SearchPanel.vue": [
		"c033",
		"Client0~CommonCode0~Order0~OrderAck0~OrderAmount0~OrderAnalysis0~ProductCode0~Purchase0~PurchaseTax0~aac84a3b",
		"view-Supplier-OrderAck-SearchPanel-vue"
	],
	"./Supplier/Quotation/Action.vue": [
		"7221",
		"view-Supplier-Quotation-Action-vue"
	],
	"./Supplier/Quotation/Detail.vue": [
		"7a57",
		"Client0~CommonCode0~Order0~OrderAck0~OrderAmount0~OrderAnalysis0~ProductCode0~Purchase0~PurchaseTax0~aac84a3b",
		"Client0~CommonCode0~Order0~OrderAck0~OrderAmount0~OrderAnalysis0~ProductCode0~Purchase0~PurchaseTax0~c2760ff0",
		"view-Code-Client-DetailForm-vue",
		"Client0",
		"view-Supplier-Quotation-Detail-vue"
	],
	"./Supplier/Quotation/DetailForm.vue": [
		"f778",
		"Client0~CommonCode0~Order0~OrderAck0~OrderAmount0~OrderAnalysis0~ProductCode0~Purchase0~PurchaseTax0~aac84a3b",
		"Client0~CommonCode0~Order0~OrderAck0~OrderAmount0~OrderAnalysis0~ProductCode0~Purchase0~PurchaseTax0~c2760ff0",
		"ShipCode0~view-Buyer-Order-DetailForm-vue~view-Buyer-Purchase-DetailForm-vue~view-Buyer-PurchaseTax-~73523415",
		"view-Supplier-Quotation-DetailForm-vue"
	],
	"./Supplier/Quotation/Item.vue": [
		"d990",
		"Client0~CommonCode0~Order0~OrderAck0~OrderAmount0~OrderAnalysis0~ProductCode0~Purchase0~PurchaseTax0~aac84a3b",
		"Client0~CommonCode0~Order0~OrderAck0~OrderAmount0~OrderAnalysis0~ProductCode0~Purchase0~PurchaseTax0~c2760ff0",
		"view-Code-Client-DetailForm-vue",
		"Client0",
		"view-Supplier-Quotation-Item-vue"
	],
	"./Supplier/Quotation/List.vue": [
		"d3b2",
		"view-Buyer-Order-List-vue~view-Buyer-Purchase-List-vue~view-Buyer-PurchaseTax-List-vue~view-Buyer-Qu~bde1fb3b",
		"view-Supplier-Quotation-List-vue"
	],
	"./Supplier/Quotation/Main.vue": [
		"8d52",
		"Client0~CommonCode0~Order0~OrderAck0~OrderAmount0~OrderAnalysis0~ProductCode0~Purchase0~PurchaseTax0~aac84a3b",
		"Client0~CommonCode0~Order0~OrderAck0~OrderAmount0~OrderAnalysis0~ProductCode0~Purchase0~PurchaseTax0~c2760ff0",
		"view-Code-Client-DetailForm-vue",
		"Client0",
		"Quotation0"
	],
	"./Supplier/Quotation/SearchPanel.vue": [
		"01b8",
		"Client0~CommonCode0~Order0~OrderAck0~OrderAmount0~OrderAnalysis0~ProductCode0~Purchase0~PurchaseTax0~aac84a3b",
		"view-Supplier-Quotation-SearchPanel-vue"
	],
	"./Supplier/Quotation4STOM/Action.vue": [
		"630d",
		"view-Supplier-Quotation4STOM-Action-vue"
	],
	"./Supplier/Quotation4STOM/Detail.vue": [
		"f390",
		"Client0~CommonCode0~Order0~OrderAck0~OrderAmount0~OrderAnalysis0~ProductCode0~Purchase0~PurchaseTax0~aac84a3b",
		"Client0~CommonCode0~Order0~OrderAck0~OrderAmount0~OrderAnalysis0~ProductCode0~Purchase0~PurchaseTax0~c2760ff0",
		"view-Code-Client-DetailForm-vue",
		"Client0",
		"view-Supplier-Quotation4STOM-Detail-vue"
	],
	"./Supplier/Quotation4STOM/DetailForm.vue": [
		"e5f1",
		"Client0~CommonCode0~Order0~OrderAck0~OrderAmount0~OrderAnalysis0~ProductCode0~Purchase0~PurchaseTax0~aac84a3b",
		"Client0~CommonCode0~Order0~OrderAck0~OrderAmount0~OrderAnalysis0~ProductCode0~Purchase0~PurchaseTax0~c2760ff0",
		"ShipCode0~view-Buyer-Order-DetailForm-vue~view-Buyer-Purchase-DetailForm-vue~view-Buyer-PurchaseTax-~73523415",
		"view-Supplier-Quotation4STOM-DetailForm-vue"
	],
	"./Supplier/Quotation4STOM/Item.vue": [
		"a241",
		"Client0~CommonCode0~Order0~OrderAck0~OrderAmount0~OrderAnalysis0~ProductCode0~Purchase0~PurchaseTax0~aac84a3b",
		"Client0~CommonCode0~Order0~OrderAck0~OrderAmount0~OrderAnalysis0~ProductCode0~Purchase0~PurchaseTax0~c2760ff0",
		"view-Code-Client-DetailForm-vue",
		"Client0",
		"view-Supplier-Quotation4STOM-Item-vue"
	],
	"./Supplier/Quotation4STOM/List.vue": [
		"b0be",
		"view-Buyer-Order-List-vue~view-Buyer-Purchase-List-vue~view-Buyer-PurchaseTax-List-vue~view-Buyer-Qu~bde1fb3b",
		"view-Supplier-Quotation4STOM-List-vue"
	],
	"./Supplier/Quotation4STOM/Main.vue": [
		"ad39",
		"Client0~CommonCode0~Order0~OrderAck0~OrderAmount0~OrderAnalysis0~ProductCode0~Purchase0~PurchaseTax0~aac84a3b",
		"Client0~CommonCode0~Order0~OrderAck0~OrderAmount0~OrderAnalysis0~ProductCode0~Purchase0~PurchaseTax0~c2760ff0",
		"view-Code-Client-DetailForm-vue",
		"Client0",
		"Quotation4STOM0"
	],
	"./Supplier/Quotation4STOM/SearchPanel.vue": [
		"83d8",
		"Client0~CommonCode0~Order0~OrderAck0~OrderAmount0~OrderAnalysis0~ProductCode0~Purchase0~PurchaseTax0~aac84a3b",
		"view-Supplier-Quotation4STOM-SearchPanel-vue"
	],
	"./Supplier/RfqBox/Action.vue": [
		"2ead",
		"view-Supplier-RfqBox-Action-vue"
	],
	"./Supplier/RfqBox/Detail.vue": [
		"8042",
		"Client0~CommonCode0~Order0~OrderAck0~OrderAmount0~OrderAnalysis0~ProductCode0~Purchase0~PurchaseTax0~aac84a3b",
		"Client0~CommonCode0~Order0~OrderAck0~OrderAmount0~OrderAnalysis0~ProductCode0~Purchase0~PurchaseTax0~c2760ff0",
		"view-Code-Client-DetailForm-vue",
		"Client0",
		"view-Supplier-RfqBox-Detail-vue"
	],
	"./Supplier/RfqBox/DetailForm.vue": [
		"4663",
		"Client0~CommonCode0~Order0~OrderAck0~OrderAmount0~OrderAnalysis0~ProductCode0~Purchase0~PurchaseTax0~aac84a3b",
		"Client0~CommonCode0~Order0~OrderAck0~OrderAmount0~OrderAnalysis0~ProductCode0~Purchase0~PurchaseTax0~c2760ff0",
		"ShipCode0~view-Buyer-Order-DetailForm-vue~view-Buyer-Purchase-DetailForm-vue~view-Buyer-PurchaseTax-~73523415",
		"view-Supplier-RfqBox-DetailForm-vue"
	],
	"./Supplier/RfqBox/Item.vue": [
		"1163",
		"Client0~CommonCode0~Order0~OrderAck0~OrderAmount0~OrderAnalysis0~ProductCode0~Purchase0~PurchaseTax0~aac84a3b",
		"Client0~CommonCode0~Order0~OrderAck0~OrderAmount0~OrderAnalysis0~ProductCode0~Purchase0~PurchaseTax0~c2760ff0",
		"view-Code-Client-DetailForm-vue",
		"Client0",
		"view-Supplier-RfqBox-Item-vue"
	],
	"./Supplier/RfqBox/List.vue": [
		"919f",
		"view-Buyer-Order-List-vue~view-Buyer-Purchase-List-vue~view-Buyer-PurchaseTax-List-vue~view-Buyer-Qu~bde1fb3b",
		"view-Supplier-RfqBox-List-vue"
	],
	"./Supplier/RfqBox/Main.vue": [
		"2236",
		"Client0~CommonCode0~Order0~OrderAck0~OrderAmount0~OrderAnalysis0~ProductCode0~Purchase0~PurchaseTax0~aac84a3b",
		"Client0~CommonCode0~Order0~OrderAck0~OrderAmount0~OrderAnalysis0~ProductCode0~Purchase0~PurchaseTax0~c2760ff0",
		"view-Code-Client-DetailForm-vue",
		"Client0",
		"RfqBox0"
	],
	"./Supplier/RfqBox/SearchPanel.vue": [
		"78a3",
		"Client0~CommonCode0~Order0~OrderAck0~OrderAmount0~OrderAnalysis0~ProductCode0~Purchase0~PurchaseTax0~aac84a3b",
		"view-Supplier-RfqBox-SearchPanel-vue"
	],
	"./Supplier/Sales/Action.vue": [
		"1d96",
		"view-Supplier-Sales-Action-vue"
	],
	"./Supplier/Sales/Detail.vue": [
		"b9e8",
		"Client0~CommonCode0~Order0~OrderAck0~OrderAmount0~OrderAnalysis0~ProductCode0~Purchase0~PurchaseTax0~aac84a3b",
		"Client0~CommonCode0~Order0~OrderAck0~OrderAmount0~OrderAnalysis0~ProductCode0~Purchase0~PurchaseTax0~c2760ff0",
		"view-Code-Client-DetailForm-vue",
		"Client0",
		"view-Supplier-Sales-Detail-vue"
	],
	"./Supplier/Sales/DetailForm.vue": [
		"9305",
		"Client0~CommonCode0~Order0~OrderAck0~OrderAmount0~OrderAnalysis0~ProductCode0~Purchase0~PurchaseTax0~aac84a3b",
		"Client0~CommonCode0~Order0~OrderAck0~OrderAmount0~OrderAnalysis0~ProductCode0~Purchase0~PurchaseTax0~c2760ff0",
		"ShipCode0~view-Buyer-Order-DetailForm-vue~view-Buyer-Purchase-DetailForm-vue~view-Buyer-PurchaseTax-~73523415",
		"view-Supplier-Sales-DetailForm-vue"
	],
	"./Supplier/Sales/Item.vue": [
		"34fb",
		"Client0~CommonCode0~Order0~OrderAck0~OrderAmount0~OrderAnalysis0~ProductCode0~Purchase0~PurchaseTax0~aac84a3b",
		"Client0~CommonCode0~Order0~OrderAck0~OrderAmount0~OrderAnalysis0~ProductCode0~Purchase0~PurchaseTax0~c2760ff0",
		"view-Code-Client-DetailForm-vue",
		"Client0",
		"view-Supplier-Sales-Item-vue"
	],
	"./Supplier/Sales/List.vue": [
		"64d4",
		"view-Buyer-Order-List-vue~view-Buyer-Purchase-List-vue~view-Buyer-PurchaseTax-List-vue~view-Buyer-Qu~bde1fb3b",
		"view-Supplier-Sales-List-vue"
	],
	"./Supplier/Sales/Main.vue": [
		"a4ff",
		"Client0~CommonCode0~Order0~OrderAck0~OrderAmount0~OrderAnalysis0~ProductCode0~Purchase0~PurchaseTax0~aac84a3b",
		"Client0~CommonCode0~Order0~OrderAck0~OrderAmount0~OrderAnalysis0~ProductCode0~Purchase0~PurchaseTax0~c2760ff0",
		"view-Code-Client-DetailForm-vue",
		"Client0",
		"Sales0"
	],
	"./Supplier/Sales/SearchPanel.vue": [
		"c737",
		"Client0~CommonCode0~Order0~OrderAck0~OrderAmount0~OrderAnalysis0~ProductCode0~Purchase0~PurchaseTax0~aac84a3b",
		"view-Supplier-Sales-SearchPanel-vue"
	],
	"./Supplier/SalesTax/Action.vue": [
		"af51",
		"view-Supplier-SalesTax-Action-vue"
	],
	"./Supplier/SalesTax/Detail.vue": [
		"d528",
		"Client0~CommonCode0~Order0~OrderAck0~OrderAmount0~OrderAnalysis0~ProductCode0~Purchase0~PurchaseTax0~aac84a3b",
		"Client0~CommonCode0~Order0~OrderAck0~OrderAmount0~OrderAnalysis0~ProductCode0~Purchase0~PurchaseTax0~c2760ff0",
		"view-Code-Client-DetailForm-vue",
		"Client0",
		"view-Supplier-SalesTax-Detail-vue"
	],
	"./Supplier/SalesTax/DetailForm.vue": [
		"3b70",
		"Client0~CommonCode0~Order0~OrderAck0~OrderAmount0~OrderAnalysis0~ProductCode0~Purchase0~PurchaseTax0~aac84a3b",
		"Client0~CommonCode0~Order0~OrderAck0~OrderAmount0~OrderAnalysis0~ProductCode0~Purchase0~PurchaseTax0~c2760ff0",
		"ShipCode0~view-Buyer-Order-DetailForm-vue~view-Buyer-Purchase-DetailForm-vue~view-Buyer-PurchaseTax-~73523415",
		"view-Supplier-SalesTax-DetailForm-vue"
	],
	"./Supplier/SalesTax/Item.vue": [
		"0bb1",
		"Client0~CommonCode0~Order0~OrderAck0~OrderAmount0~OrderAnalysis0~ProductCode0~Purchase0~PurchaseTax0~aac84a3b",
		"Client0~CommonCode0~Order0~OrderAck0~OrderAmount0~OrderAnalysis0~ProductCode0~Purchase0~PurchaseTax0~c2760ff0",
		"view-Code-Client-DetailForm-vue",
		"Client0",
		"view-Supplier-SalesTax-Item-vue"
	],
	"./Supplier/SalesTax/List.vue": [
		"a163",
		"view-Buyer-Order-List-vue~view-Buyer-Purchase-List-vue~view-Buyer-PurchaseTax-List-vue~view-Buyer-Qu~bde1fb3b",
		"view-Supplier-SalesTax-List-vue"
	],
	"./Supplier/SalesTax/Main.vue": [
		"a4e6",
		"Client0~CommonCode0~Order0~OrderAck0~OrderAmount0~OrderAnalysis0~ProductCode0~Purchase0~PurchaseTax0~aac84a3b",
		"Client0~CommonCode0~Order0~OrderAck0~OrderAmount0~OrderAnalysis0~ProductCode0~Purchase0~PurchaseTax0~c2760ff0",
		"view-Code-Client-DetailForm-vue",
		"Client0",
		"SalesTax0"
	],
	"./Supplier/SalesTax/SearchPanel.vue": [
		"8c8c",
		"Client0~CommonCode0~Order0~OrderAck0~OrderAmount0~OrderAnalysis0~ProductCode0~Purchase0~PurchaseTax0~aac84a3b",
		"view-Supplier-SalesTax-SearchPanel-vue"
	],
	"./Sys/Login.vue": [
		"f618",
		"Login0"
	],
	"./temp/buy/Requisitions/Action.vue": [
		"1541",
		"view-temp-buy-Requisitions-Action-vue"
	],
	"./temp/buy/Requisitions/Detail.vue": [
		"52c8",
		"Client0~CommonCode0~Order0~OrderAck0~OrderAmount0~OrderAnalysis0~ProductCode0~Purchase0~PurchaseTax0~aac84a3b",
		"view-temp-buy-Requisitions-Detail-vue"
	],
	"./temp/buy/Requisitions/DetailForm.vue": [
		"ff9f",
		"Client0~CommonCode0~Order0~OrderAck0~OrderAmount0~OrderAnalysis0~ProductCode0~Purchase0~PurchaseTax0~aac84a3b",
		"view-temp-buy-Requisitions-DetailForm-vue"
	],
	"./temp/buy/Requisitions/Item.vue": [
		"04de",
		"Client0~CommonCode0~Order0~OrderAck0~OrderAmount0~OrderAnalysis0~ProductCode0~Purchase0~PurchaseTax0~aac84a3b",
		"view-temp-buy-Requisitions-Item-vue"
	],
	"./temp/buy/Requisitions/List.vue": [
		"97ce",
		"view-temp-buy-Requisitions-List-vue"
	],
	"./temp/buy/Requisitions/Main.vue": [
		"18fe",
		"Client0~CommonCode0~Order0~OrderAck0~OrderAmount0~OrderAnalysis0~ProductCode0~Purchase0~PurchaseTax0~aac84a3b",
		"view-temp-buy-Requisitions-Main-vue~view-temp-sales-req-req-vue~view-temp-sales-sales-sales-vue~view~d37ad7a7",
		"view-temp-buy-Requisitions-Main-vue"
	],
	"./temp/buy/Requisitions/SearchPanel.vue": [
		"b05e",
		"Client0~CommonCode0~Order0~OrderAck0~OrderAmount0~OrderAnalysis0~ProductCode0~Purchase0~PurchaseTax0~aac84a3b",
		"view-temp-buy-Requisitions-SearchPanel-vue"
	],
	"./temp/buy/ShipCode/Action.vue": [
		"b30c",
		"Client0~CommonCode0~Order0~OrderAck0~OrderAmount0~OrderAnalysis0~ProductCode0~Purchase0~PurchaseTax0~c2760ff0",
		"view-temp-buy-ShipCode-Action-vue"
	],
	"./temp/buy/ShipCode/Detail.vue": [
		"216e",
		"Client0~CommonCode0~Order0~OrderAck0~OrderAmount0~OrderAnalysis0~ProductCode0~Purchase0~PurchaseTax0~aac84a3b",
		"view-temp-buy-ShipCode-Detail-vue"
	],
	"./temp/buy/ShipCode/DetailForm.vue": [
		"a549",
		"view-temp-buy-ShipCode-DetailForm-vue"
	],
	"./temp/buy/ShipCode/Item.vue": [
		"aacb",
		"Client0~CommonCode0~Order0~OrderAck0~OrderAmount0~OrderAnalysis0~ProductCode0~Purchase0~PurchaseTax0~aac84a3b",
		"view-temp-buy-ShipCode-Item-vue"
	],
	"./temp/buy/ShipCode/List.vue": [
		"9cb8",
		"view-temp-buy-ShipCode-List-vue"
	],
	"./temp/buy/ShipCode/Main.vue": [
		"1eb8",
		"view-temp-buy-ShipCode-Main-vue"
	],
	"./temp/buy/ShipCode/SearchPanel.vue": [
		"adf9",
		"Client0~CommonCode0~Order0~OrderAck0~OrderAmount0~OrderAnalysis0~ProductCode0~Purchase0~PurchaseTax0~aac84a3b",
		"Client0~CommonCode0~Order0~OrderAck0~OrderAmount0~OrderAnalysis0~ProductCode0~Purchase0~PurchaseTax0~c2760ff0",
		"view-temp-buy-ShipCode-SearchPanel-vue"
	],
	"./temp/buy/ShipCode/ShipCode.vue": [
		"08f6",
		"Client0~CommonCode0~Order0~OrderAck0~OrderAmount0~OrderAnalysis0~ProductCode0~Purchase0~PurchaseTax0~aac84a3b",
		"Client0~CommonCode0~Order0~OrderAck0~OrderAmount0~OrderAnalysis0~ProductCode0~Purchase0~PurchaseTax0~c2760ff0",
		"view-temp-buy-ShipCode-ShipCode-vue"
	],
	"./temp/sales/req/req.vue": [
		"8ae1",
		"view-temp-buy-Requisitions-Main-vue~view-temp-sales-req-req-vue~view-temp-sales-sales-sales-vue~view~d37ad7a7",
		"view-temp-sales-req-req-vue"
	],
	"./temp/sales/sales/componentA.vue": [
		"42b9",
		"view-temp-sales-sales-componentA-vue"
	],
	"./temp/sales/sales/sales.vue": [
		"e7de",
		"Client0~CommonCode0~Order0~OrderAck0~OrderAmount0~OrderAnalysis0~ProductCode0~Purchase0~PurchaseTax0~aac84a3b",
		"view-temp-buy-Requisitions-Main-vue~view-temp-sales-req-req-vue~view-temp-sales-sales-sales-vue~view~d37ad7a7",
		"view-temp-sales-sales-sales-vue"
	],
	"./temp/sales/salesTypeC/Detail.vue": [
		"c9e46",
		"Client0~CommonCode0~Order0~OrderAck0~OrderAmount0~OrderAnalysis0~ProductCode0~Purchase0~PurchaseTax0~aac84a3b",
		"view-temp-sales-salesTypeC-Detail-vue"
	],
	"./temp/sales/salesTypeC/DetailForm.vue": [
		"d33c",
		"Client0~CommonCode0~Order0~OrderAck0~OrderAmount0~OrderAnalysis0~ProductCode0~Purchase0~PurchaseTax0~aac84a3b",
		"view-temp-sales-salesTypeC-DetailForm-vue"
	],
	"./temp/sales/salesTypeC/Item.vue": [
		"16d6",
		"Client0~CommonCode0~Order0~OrderAck0~OrderAmount0~OrderAnalysis0~ProductCode0~Purchase0~PurchaseTax0~aac84a3b",
		"view-temp-sales-salesTypeC-Item-vue"
	],
	"./temp/sales/salesTypeC/List.vue": [
		"75a5",
		"view-temp-sales-salesTypeC-List-vue"
	],
	"./temp/sales/salesTypeC/SearchPanel.vue": [
		"8b32",
		"Client0~CommonCode0~Order0~OrderAck0~OrderAmount0~OrderAnalysis0~ProductCode0~Purchase0~PurchaseTax0~aac84a3b",
		"view-temp-sales-salesTypeC-SearchPanel-vue"
	],
	"./temp/sales/salesTypeC/salesTypeC.vue": [
		"cf5e",
		"Client0~CommonCode0~Order0~OrderAck0~OrderAmount0~OrderAnalysis0~ProductCode0~Purchase0~PurchaseTax0~aac84a3b",
		"view-temp-buy-Requisitions-Main-vue~view-temp-sales-req-req-vue~view-temp-sales-sales-sales-vue~view~d37ad7a7",
		"view-temp-sales-salesTypeC-salesTypeC-vue"
	],
	"./temp/sample/Paging.vue": [
		"14b9",
		"Client0~CommonCode0~Order0~OrderAck0~OrderAmount0~OrderAnalysis0~ProductCode0~Purchase0~PurchaseTax0~aac84a3b",
		"view-temp-sample-Paging-vue"
	],
	"./temp/sample/Sample1.vue": [
		"1458",
		"view-temp-sample-Sample1-vue"
	],
	"./temp/sample/Sample2.vue": [
		"48b5",
		"view-temp-sample-Sample2-vue"
	],
	"./temp/sample/Sample2Insert.vue": [
		"96d5",
		"view-temp-sample-Sample2Insert-vue"
	],
	"./temp/sample/Sample3.vue": [
		"4875",
		"Client0~CommonCode0~Order0~OrderAck0~OrderAmount0~OrderAnalysis0~ProductCode0~Purchase0~PurchaseTax0~aac84a3b",
		"view-temp-sample-Sample3-vue"
	],
	"./temp/sample/Sample3Detail.vue": [
		"e417",
		"view-temp-sample-Sample3Detail-vue"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "1a5d";
module.exports = webpackAsyncContext;